import styled from 'styled-components';

export const FooterSection = styled.div`
  flex: 1;
`;
